import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import { useSnackbar } from "notistack"
import PerfectScrollbar from "react-perfect-scrollbar";
import InfiniteScroll from "react-infinite-scroll-component";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { changeNotificationStatus } from "../../../../../redux/features/notifications/notificationActions";
// Services
import * as notificationService from "../../../../../services/Notifications";
// Components
import { getIconByNotificationType } from "../../../../utils/utilityFunctions";
// Material UI ICons
import { makeStyles, List, ListItem, ListItemAvatar, ListItemText, Typography, Divider, Backdrop, CircularProgress } from "@material-ui/core";
import { ImDropbox } from 'react-icons/im'

const styles = {
    highlighted: {
        backgroundColor: "#e5e5e5",
        WebkitTransition: 'all 0.5s',
        msTransition: 'all 0.5s'
    },
    normal: {
        backgroundColor: 'unset',
        WebkitTransition: 'all 0.5s',
        msTransition: 'all 0.5s'
    }
}

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

const Notifications = props => {

    const classes = useStyles();

    const { enqueueSnackbar } = useSnackbar();
    const intl = useIntl();

    const dispatch = useDispatch();
    const { currentStakeholder } = useSelector(state => state.stakeholder);

    const [loading, setLoading] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [selectedNotificationId, setSelectedNotificationId] = useState(undefined);
    let [totalCount, setTotalCount] = useState(0);
    let [page, setPage] = useState(1);

    useEffect(() => {
        (async function getAllNotifications() {
            try {
                setLoading(true);
                const resp = await notificationService.getNotificationsByStakeholderId(currentStakeholder._id);
                setNotifications(resp.data.list);
                setTotalCount(resp.data.count);
                const notificationId = props.match.params.id;
                if (notificationId) {
                    setSelectedNotificationId(notificationId);
                    setTimeout(() => {
                        setSelectedNotificationId(undefined);
                    }, 5000);
                    dispatch(changeNotificationStatus(notificationId));
                }
            } catch (err) {
                console.error(err);
                enqueueSnackbar(intl.formatMessage({ id: err?.response?.data.message || err.message }),
                    { variant: 'error' });
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const fetchMoreNotifications = async () => {
        try {
            const resp = await notificationService.getNotificationsByStakeholderId(currentStakeholder._id, undefined, page);
            setPage(++page);
            const mergedNotifications = [...notifications, ...resp.data.list];
            setNotifications(mergedNotifications);
        } catch (err) {
            console.error(err);
            enqueueSnackbar(intl.formatMessage({ id: err?.response?.data.message || err.message }),
                { variant: 'error' });
        }
    }

    return (
        <div className="container-fluid">
            <div className="d-flex flex-row">
                <div className="flex-row-auto offcanvas-mobile w-100" id="kt_profile_aside">
                    <div className="card card-custom card-stretch" style={{ height: '49rem' }}>
                        <div className="p-8 border-bottom">
                            <Typography variant="h5" gutterBottom><FormattedMessage id="user_notifications" /></Typography>
                        </div>
                        <div className="card-body pt-1 w-100">
                            {
                                loading ?
                                    <Backdrop open={loading} className={classes.backdrop}>
                                        <CircularProgress color="secondary" />
                                    </Backdrop>
                                    : notifications?.length
                                        ? <List style={{ height: '40em' }}>
                                            <PerfectScrollbar
                                                id="perfectScrollbar"
                                                options={{
                                                    wheelSpeed: 2,
                                                    wheelPropagation: false
                                                }}
                                                className="scroll pr-7 mr-n7"
                                                style={{ maxHeight: "40em", position: "relative" }}
                                            >
                                                <InfiniteScroll
                                                    dataLength={notifications.length}
                                                    next={fetchMoreNotifications}
                                                    hasMore={notifications.length < totalCount}
                                                    loader={<div className="d-flex justify-content-center p-4"><CircularProgress /></div>}
                                                    scrollableTarget="perfectScrollbar"
                                                    endMessage={<div className="d-flex justify-content-center text-muted p-4"><FormattedMessage id="no_more_notification" /></div>}
                                                    scrollThreshold={1}
                                                >
                                                    {
                                                        notifications.map((n, i) => (
                                                            <div key={i} style={n._id === selectedNotificationId ? styles.highlighted : styles.normal}>
                                                                <ListItem key={i} >
                                                                    <ListItemAvatar><div>{getIconByNotificationType[n.type]}</div></ListItemAvatar>
                                                                    <ListItemText
                                                                        primary={<FormattedMessage id={n.type} />}
                                                                        secondary={<span className="d-flex flex-column">
                                                                            <FormattedMessage id={n.content} />
                                                                            <span className="text-muted mt-2">{moment(n.createdAt).format("DD MMM YYYY HH:mm")}</span>
                                                                        </span>
                                                                        }
                                                                    />
                                                                </ListItem>
                                                                <Divider variant="inset" component="li" />
                                                            </div>
                                                        ))
                                                    }
                                                </InfiniteScroll>
                                            </PerfectScrollbar>
                                        </List>
                                        : <div className="text-muted text-bold text-center mt-10 p-10">
                                            <div className="mb-5">
                                                <ImDropbox style={{ fontSize: 40 }} />
                                            </div>
                                            <div>
                                                <FormattedMessage id="no_any_notification" />
                                            </div>
                                        </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}

export default Notifications;
